module.exports = __webpack_public_path__ + "img/ep4-2.2751d16e.jpg";